export function showLoader() {
  const el = document.querySelector('.loader')
  el?.classList.add('loading')
}

export function hideLoader() {
  const el = document.querySelector('.loader')
  el?.classList.remove('loading')
}
